<template>
    <div>
    <QueryFrame :disablePage='true'>
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType === 1">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeId" :multiple='true'></storeListSelect>
          </div>
          <div class="queryItem">
            <label>商品:</label>
            <lk-input :maxlength="100" placeholder="请输入商品编码/通用名" class="item" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>关联状态:</label>
            <lk-select v-model='query.relType' class="item" clearable>
              <lk-option v-for="(item, index) in connectStatus" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="search">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div>
          <lk-button type="primary" @click="updateDir">更新医保目录</lk-button>
          <lk-button @click="handleAutoClick" style="margin-left:10px" v-if="this.currentTab === 'drug'">自动关联</lk-button>
          <lk-button type="primary" @click="upload" style="margin-left:10px">上传关联关系</lk-button>
          <lk-button type="primary" @click="showExportModal" style="margin-left:10px" v-if="ifShowExport">导出进销存上报数据</lk-button>
          <lk-button type="primary" @click="exportRelate" style="margin-left:10px" v-if="isBeiJing">导出关联关系</lk-button>
        </div>
        <div style="margin: 15px 0">
          <span v-for="(item, index) in goodsInfo" :key='index' style="margin-right:10px">{{`${item.name}:${numberInfo[item.key] ? numberInfo[item.key] : ''}`}}</span>
        </div>
        <div class="tabsArea">
          <lk-tabs value="drug" :animated='false' @on-click='handleClickTabs'>
            <lk-tab-pane label="药品" name="drug">
              <lk-table border :columns="drugColumns" :data="tableDrugData"></lk-table>
              <lk-page
                :total="drug.drugTotal"
                :page-size='drug.drugSize'
                show-total
                show-sizer
                show-elevator
                class="page-top"
                @on-change='handlePageDrug'
                @on-page-size-change='handleSizeDrug'
                :current.sync="drug.pageDrug">
              </lk-page>
            </lk-tab-pane>
            <lk-tab-pane label="医疗器械" name="equipment">
              <lk-table border :columns="equipmentColumns" :data="tableEquipData"></lk-table>
              <lk-page
                :total="equipment.total"
                :page-size='equipment.size'
                show-total
                show-sizer
                show-elevator
                class="page-top"
                @on-change='handlePageEquip'
                @on-page-size-change='handleSizeEquip'
                :current.sync="equipment.page">
              </lk-page>
            </lk-tab-pane>
            <lk-tab-pane label="中药饮片" name="chineseDrug">
              <lk-table border :columns="chineseDrugColumns" :data="tableChiDrugData"></lk-table>
              <lk-page
                :total="chiDrug.total"
                :page-size='chiDrug.size'
                show-total
                show-sizer
                show-elevator
                class="page-top"
                @on-change='handlePageChiDrug'
                @on-page-size-change='handleSizeChiDrug'
                :current.sync="chiDrug.page">
              </lk-page>
            </lk-tab-pane>
          </lk-tabs>
        </div>
      </div>
    </QueryFrame>
    <loadingSpan v-if="loading"></loadingSpan>
    <connectModal
      :showModal='ifShow'
      :columns='modalColumns'
      :goodsType2='currentGoodsType'
      :exhibitInfoRules='drugInfo'
      :exhibitObj='tempDrug'
      @change='modalChange'
      @update='handleUpdate'
    ></connectModal>
    <lk-modal
      @on-ok='retreat'
      v-model="modalConnect"
      title='撤销关联'
    >
      <p>是否确认撤销关联?</p>
    </lk-modal>
    <lk-modal
      @on-ok='confirmAuto'
      v-model="modalAutoConnect"
      title='自动匹配'
    >
      <p>将按批准文号自动匹配未关联商品，是否确认?</p>
    </lk-modal>
    <lk-modal v-model="showDuration"
      :footer-hide='true'
      title="导出进销存上报数据"
      width="330"
      @on-cancel="exportCancel">
      <div class="uploadContainer">
        <div style="display:flex">
          <span style="margin-top:8px">导出时间范围：</span>
          <timeStampDatePicker style="width:200px" type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='exportDuration' />
        </div>
          <div class="buttons">
              <lk-button type='primary' class="cancel" @click="downloadData">确认导出</lk-button>
          </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import system from '@/services/system';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import connectModal from './connectModal.vue';
import healthInsManage from '../../services/healthInsManage';
import loadingSpan from '../../components/LoadingSpan.vue';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';

export default {
  name: 'drugCompareCode',
  mixins: [mapState],
  components: {
    QueryFrame, connectModal, loadingSpan, timeStampDatePicker,
  },
  computed: {
    ifShowExport() {
      return this.$store.state.storeInfo.id === 26; // 测试：125，线上：成都：26
    },
    isBeiJing() {
      return this.$store.state.storeInfo.id === 7;
    },
  },
  data() {
    return {
      showDuration: false,
      exportDuration: [],
      ifShow: false,
      loading: false,
      modalAutoConnect: false,
      modalConnect: false,
      currentTab: 'drug',
      drugModal: true,
      query: {
        storeId: null,
        name: null,
        relType: null,
      },
      tableDrugData: [],
      drugColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 110,
          align: 'center',
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '关联状态',
          key: 'relTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '上传状态',
          key: 'uploadTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: 'ERP商品信息',
          align: 'center',
          children: [
            {
              title: '编码',
              key: 'code',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '通用名',
              key: 'approvedName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '商品名',
              key: 'goodsName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '规格',
              key: 'goodsSpec',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '剂型',
              key: 'dosageFormName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '生产厂家',
              key: 'producer',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '批准文号',
              key: 'approvalCode',
              minWidth: 110,
              tooltip: true,
            },
          ],
        },
        {
          title: '医保中心商品信息',
          align: 'center',
          children: [
            {
              title: '编码',
              key: 'medListCodg',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '中文名称',
              key: 'medGoodsName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '批准文号',
              key: 'medApprovalCode',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '规格',
              key: 'medSpec',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '处方药标志',
              key: 'prescriptionTypeName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '剂型',
              key: 'medDosform',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '药品类别',
              key: 'medGoodsType',
              minWidth: 110,
              tooltip: true,
            },
          ],
        },
        {
          title: '操作',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h('div', [
            (params.row.relType === 0) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempDrug = params.row;
                  this.currentGoodsType = params.row.goodsType;
                  this.assignModalInfo(params.row.goodsType);
                  this.ifShow = true;
                },
              },
            }, '关联') : null,
            (params.row.relType === 1 || params.row.relType === 2) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempDrug = params.row;
                  this.currentGoodsType = params.row.goodsType;
                  this.assignModalInfo(params.row.goodsType);
                  this.ifShow = true;
                },
              },
            }, '修改') : null,
            (params.row.relType === 2 || params.row.relType === 1) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const param = {
                    id: params.row.id,
                    uploadType: params.row.uploadType || '',
                    goodsTypeCode: params.row.goodsType || '',
                    fixmedinsHilistId: params.row.code || '',
                    medListCodg: params.row.medListCodg || '',
                  };
                  this.modalConnect = true;
                  this.retreatParam = param;
                },
              },
            }, '撤销') : null,
          ]),
        },
      ],
      retreatParam: {},
      tableEquipData: [],
      equipmentColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 110,
          align: 'center',
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '关联状态',
          key: 'relTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '上传状态',
          key: 'uploadTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: 'ERP商品信息',
          align: 'center',
          children: [
            {
              title: '编码',
              key: 'code',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '通用名',
              key: 'approvedName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '商品名',
              key: 'goodsName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '规格',
              key: 'goodsSpec',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '剂型',
              key: 'dosageFormName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '生产厂家',
              key: 'producer',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '注册证号',
              key: 'approvalCode',
              minWidth: 110,
              tooltip: true,
            },
          ],
        },
        {
          title: '医保中心商品信息',
          align: 'center',
          children: [
            {
              title: '编码',
              key: 'medListCodg',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '耗材名称',
              key: 'medGoodsName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '注册备案号',
              key: 'mdRegFilNo',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '医疗器械唯一标识码',
              key: 'unionCode',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '医保通用名',
              key: 'generalName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '产品型号',
              key: 'model',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '规格',
              key: 'spec',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '耗材分类',
              key: 'classify',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '规格型号',
              key: 'specModel',
              minWidth: 110,
              tooltip: true,
            },
          ],
        },
        {
          title: '操作',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h('div', [
            (params.row.relType === 0) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempDrug = params.row;
                  this.currentGoodsType = params.row.goodsType;
                  this.assignModalInfo(params.row.goodsType);
                  this.ifShow = true;
                },
              },
            }, '关联') : null,
            (params.row.relType === 1 || params.row.relType === 2) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempDrug = params.row;
                  this.currentGoodsType = params.row.goodsType;
                  this.assignModalInfo(params.row.goodsType);
                  this.ifShow = true;
                },
              },
            }, '修改') : null,
            (params.row.relType === 2 || params.row.relType === 1) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const param = {
                    id: params.row.id,
                    relType: params.row.relType || '',
                  };
                  this.modalConnect = true;
                  this.retreatParam = param;
                },
              },
            }, '撤销') : null,
          ]),
        },
      ],
      tableChiDrugData: [],
      chineseDrugColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 110,
          align: 'center',
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '关联状态',
          key: 'relTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '上传状态',
          key: 'uploadTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: 'ERP商品信息',
          align: 'center',
          children: [
            {
              title: '编码',
              key: 'code',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '通用名',
              key: 'approvedName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '商品名',
              key: 'goodsName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '规格',
              key: 'goodsSpec',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '剂型',
              key: 'dosageFormName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '生产厂家',
              key: 'producer',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '批准文号',
              key: 'approvalCode',
              minWidth: 110,
              tooltip: true,
            },
          ],
        },
        {
          title: '医保中心商品信息',
          align: 'center',
          children: [
            {
              title: '编码',
              key: 'medListCodg',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '单味药名称',
              key: 'medGoodsName',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '单复方标志',
              key: 'mark',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '常规用法',
              key: 'conUsage',
              minWidth: 110,
              tooltip: true,
            },
            {
              title: '品种',
              key: 'variety',
              minWidth: 110,
              tooltip: true,
            },
          ],
        },
        {
          title: '操作',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h('div', [
            (params.row.relType === 0) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempDrug = params.row;
                  this.currentGoodsType = params.row.goodsType;
                  this.assignModalInfo(params.row.goodsType);
                  this.ifShow = true;
                },
              },
            }, '关联') : null,
            (params.row.relType === 1 || params.row.relType === 2) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.tempDrug = params.row;
                  this.currentGoodsType = params.row.goodsType;
                  this.assignModalInfo(params.row.goodsType);
                  this.ifShow = true;
                },
              },
            }, '修改') : null,
            (params.row.relType === 2 || params.row.relType === 1) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const param = {
                    id: params.row.id,
                    relType: params.row.relType || '',
                  };
                  this.modalConnect = true;
                  this.retreatParam = param;
                },
              },
            }, '撤销') : null,
          ]),
        },
      ],
      connectStatus: [
        {
          value: 0,
          name: '未关联',
        },
        {
          value: 1,
          name: '已关联',
        },
        {
          value: 2,
          name: '无匹配',
        },
      ],
      goodsInfo: [
        {
          name: '全部商品',
          key: 'allCount',
        },
        {
          name: '未关联',
          key: 'noMatchCount',
        },
        {
          name: '已关联',
          key: 'relCount',
        },
        {
          name: '无匹配',
          key: 'notRelCount',
        },
        {
          name: '已上传',
          key: 'uploadCount',
        },
        {
          name: '未上传',
          key: 'noUploadCount',
        },
      ],
      numberInfo: {},
      drug: {
        drugTotal: 0,
        page: 1,
        size: 10,
      },
      equipment: {
        total: 0,
        page: 1,
        size: 10,
      },
      chiDrug: {
        total: 0,
        page: 1,
        size: 10,
      },
      modalDrugInfo: [
        {
          title: '编码',
          key: 'code',
        },
        {
          title: '通用名',
          key: 'approvedName',
        },
        {
          title: '商品名',
          key: 'goodsName',
        },
        {
          title: '规格',
          key: 'goodsSpec',
        },
        {
          title: '剂型',
          key: 'dosageFormName',
        },
        {
          title: '生产厂家',
          key: 'producer',
        },
        {
          title: '批准文号',
          key: 'approvalCode',
        },
      ],
      modalEquipInfo: [
        {
          title: '编码',
          key: 'code',
        },
        {
          title: '通用名',
          key: 'approvedName',
        },
        {
          title: '商品名',
          key: 'goodsName',
        },
        {
          title: '规格',
          key: 'goodsSpec',
        },
        {
          title: '剂型',
          key: 'dosageFormName',
        },
        {
          title: '生产厂家',
          key: 'producer',
        },
        {
          title: '注册证号',
          key: 'approvalCode',
        },
      ],
      modalChiDrugInfo: [
        {
          title: '编码',
          key: 'code',
        },
        {
          title: '通用名',
          key: 'approvedName',
        },
        {
          title: '商品名',
          key: 'goodsName',
        },
        {
          title: '规格',
          key: 'goodsSpec',
        },
        {
          title: '剂型',
          key: 'dosageFormName',
        },
      ],
      drugInfo: [],
      tempDrug: {},
      modalColumns: [],
      currentGoodsType: 1,
    };
  },
  methods: {
    modalChange(val) {
      this.ifShow = val;
    },
    handleReset() {
      this.page = 1;
      this.size = 20;
      this.query = {};
    },
    retreat(params = this.retreatParam) {
      healthInsManage.deleteDir(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('撤销成功');
          this.search();
          this.getNumbersInfo();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    confirmAuto() {
      healthInsManage.confirmAuto().then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('关联成功');
          this.search();
          this.getNumbersInfo();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleAutoClick() {
      this.modalAutoConnect = true;
    },
    assignModalInfo(type) {
      if (type === 1) {
        this.drugInfo = this.modalDrugInfo;
      } else if (type === 2) {
        this.drugInfo = this.modalEquipInfo;
      } else if (type === 3) {
        this.drugInfo = this.modalChiDrugInfo;
      }
    },
    handlePageDrug(page) {
      this.drug.page = page;
      const params = {
        size: this.drug.size,
        page: this.drug.page,
        goodsType: 1, // 药品
        name: this.query.name,
        relType: this.query.relType,
        storeId: this.query.storeId,
      };
      this.handleSearch(params);
    },
    handleSizeDrug(size) {
      this.drug.drugSize = size;
      const params = {
        size: 10,
        page: this.drug.drugSize,
      };
    },
    handlePageEquip(page) {
      this.equipment.page = page;
      const params = {
        size: this.equipment.size,
        page: this.equipment.page,
        goodsType: 2, // 医疗器械
        name: this.query.name,
        relType: this.query.relType,
        storeId: this.query.storeId,
      };
      this.handleSearch(params);
    },
    handleSizeEquip() {},
    handlePageChiDrug(page) {
      this.chiDrug.page = page;
      const params = {
        size: this.chiDrug.size,
        page: this.chiDrug.page,
        goodsType: 3, // 中药饮片
        name: this.query.name,
        relType: this.query.relType,
        storeId: this.query.storeId,
      };
      this.handleSearch(params);
    },
    handleSizeChiDrug() {},
    handleClickTabs(name) {
      this.currentTab = name;
      this.getNumbersInfo();
      this.search();
    },
    assignData(currentTab, data) {
      if (!currentTab) return;
      switch (currentTab) {
        case 'drug':
          this.tableDrugData = data.list;
          this.drug.drugTotal = data.count;
        case 'equipment':
          this.tableEquipData = data.list;
          this.equipment.total = data.count;
        case 'chineseDrug':
          this.tableChiDrugData = data.list;
          this.chiDrug.total = data.count;
      }
    },
    handleSearch(params = { page: 1, size: 10, goodsType: 1 }) {
      healthInsManage.getDrugData(params).then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          if (params.goodsType === 1) {
            const arr = ['是', '否'];
            res.data.data.list.forEach((item) => {
              if (item.prescriptionType) {
                item.prescriptionTypeName = arr[item.prescriptionType - 1];
              }
            });
          }
          this.assignData(this.currentTab, res.data.data);
          this.loading = false;
          this.getNumbersInfo();
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      });
    },
    updateDir() {
      healthInsManage.updateDir().then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('更新成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    search() {
      const name = this.currentTab;
      if (name === 'drug') {
        this.handlePageDrug(this.drug.page);
      } else if (name === 'equipment') {
        this.handlePageEquip(this.equipment.page);
      } else if (name === 'chineseDrug') {
        this.handlePageChiDrug(this.chiDrug.page);
      }
    },
    getCurrentTabNumber(tab) {
      if (tab === 'drug') return 1;
      if (tab === 'equipment') return 2;
      if (tab === 'chineseDrug') return 3;
    },
    getNumbersInfo() { // 获取关联数量信息
      const currentTabNum = this.getCurrentTabNumber(this.currentTab);
      const params = {
        goodsType: currentTabNum,
      };
      healthInsManage.getNumberInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.numberInfo = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    upload() {
      healthInsManage.confirmConnect().then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.loading = false;
          this.$Message.success('上传关联关系成功');
          this.getNumbersInfo();
          this.search();
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      });
    },
    showExportModal() {
      this.exportDuration = [];
      this.showDuration = true;
    },
    downloadData() {
      if (this.exportDuration.length < 2) {
        this.$Message.error('请选择导出时间范围');
        return;
      }
      const params = {
        storeId: this.$store.state.storeInfo.id,
        exportStartTime: this.exportDuration[0],
        exportEndTime: this.exportDuration[1],
      };
      system.inListExport(params).then((res) => {
        if (res.status === 200) {
          utils.downFile(res.data, `medPISData${utils.formatTime(new Date().getTime(), 'YYYYMMDD')}.zip`);
        } else {
          this.$Message.error(res.data.error);
        }
        this.showDuration = false;
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    exportCancel() {
      this.showDuration = false;
      this.exportDuration = [];
    },
    handleUpdate() {
      this.search();
      this.getNumbersInfo();
    },
    columnsControl() {
      if (this.roleType !== 1) { // 非总部角色不显示门店名称 1总部 2门店 3系统管理员
        this.drugColumns.splice(1, 1);
        this.equipmentColumns.splice(1, 1);
        this.chineseDrugColumns.splice(1, 1);
      }
    },
    exportRelate() {
      const params = {
        storeId: this.$store.state.storeInfo.id,
        goodsType: this.getCurrentTabNumber(this.currentTab),
        name: this.query.relType,
        relType: this.query.relType,
      };
      system.exportGoodsRel(params).then((res) => {
        if (res.status === 200) {
          utils.downFile(res.data, 'yp.in');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch();
  },
  mounted() {
    this.columnsControl();
  },
};
</script>
<style lang="less" scoped>
  .page-top {
    margin-top: 40px;
    float: right;
  }
  .uploadContainer {
    position: relative;
    height: 80px;
  }
  .buttons{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
    .cancel{
        margin-right: 16px
    }
  }
</style>
